"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const labelStyles_1 = __importDefault(require("./labelStyles"));
const styles_1 = __importDefault(require("../../styles/styles"));
const Label = ({ title, subheading }) => (react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
    typeof title === 'string' ? react_1.default.createElement(react_native_paper_1.Title, { style: styles_1.default.textTitle }, title) : title,
    react_1.default.createElement(react_native_paper_1.Subheading, { style: labelStyles_1.default.subHeading }, subheading)));
exports.default = Label;
